import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverShiftEntity } from '../../domain/entities/DriverShiftEntity'

export class DriverShiftModel extends DriverShiftEntity {
  constructor(dataDto: DriverShiftEntity) {
    super()
    mapEntityProperties<DriverShiftModel>(this, dataDto)
  }
}
